import { DateTime } from 'luxon'
import { Status } from './Status'
import { StatusDetail } from './StatusDetail'
import { useNavigate } from 'react-router-dom'
import { StatusHistory } from './StatusHistory'
import { useTw } from '../../../../../../utils/Styles'
import { localizeString } from '../../../../../../utils'
import { StatusPageQuery } from '../../StatusPage.generated'

type Props = {
  day?: string
  eventId?: string
  expand?: boolean
  component: StatusPageQuery['Profile']['statusPage']['components'][0]
}

export function Component({ component, day, expand, eventId }: Props) {
  const tw = useTw()
  const navigate = useNavigate()

  const days = component.eventsHistory
    .filter((_) => _.events.length)
    .map((_) => DateTime.fromISO(_.date).toFormat('yyyy-LL-dd'))

  const dayIndex = days.findIndex((_) => _ === day)

  return (
    <div className={tw`px-6 py-4`}>
      <header className={tw`flex justify-between w-full pb-2`}>
        <button
          className={tw`${
            days.length ? 'text-foreground cursor-pointer' : 'cursor-default'
          }`}
          onClick={() =>
            days.length && navigate(`/status-page/${component._id}/${days[0]}`)
          }
        >
          {localizeString(component.name)}
        </button>
        <Status
          componentId={component._id}
          status={{
            ...component.eventsHistory[0],
            events: component.eventsHistory[0].events.filter((_) => _.ongoing),
          }}
        />
      </header>
      <span className={tw`text-neutral-350 text-sm`}>
        {localizeString(component.description)}
      </span>
      {component.displayMode === 'HISTORY' ? (
        <StatusHistory
          day={day}
          history={component.eventsHistory}
          currentComponentId={component._id}
          routeComponentId={expand ? component._id : null}
        />
      ) : null}
      {expand ? (
        <StatusDetail
          day={day}
          eventId={eventId}
          componentId={component._id}
          displayMode={component.displayMode}
          hasNext={dayIndex !== 0}
          hasPrev={dayIndex !== days.length - 1}
          onNext={() =>
            navigate(`/status-page/${component._id}/${days[dayIndex - 1]}`)
          }
          onPrev={() =>
            navigate(`/status-page/${component._id}/${days[dayIndex + 1]}`)
          }
          historyItem={component.eventsHistory.find(
            (_) => DateTime.fromISO(_.date).toFormat('yyyy-LL-dd') === day
          )}
        />
      ) : null}
    </div>
  )
}
